import { render } from "./NewFarmerWizzardPage.vue?vue&type=template&id=1a53be9c"
import script from "./NewFarmerWizzardPage.vue?vue&type=script&lang=js"
export * from "./NewFarmerWizzardPage.vue?vue&type=script&lang=js"

import "./NewFarmerWizzardPage.vue?vue&type=style&index=0&id=1a53be9c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__